import { Theme } from "@/enums";
import { TParcelSteps } from "@/types/parcel.types";
import { getParcelGE, sendParcelGe } from "./ParcelStepsGe";
import { getParcelUk } from "./ParcelStepsUk";
import { getParcelUz } from "./ParcelStepsUz";

export const parcelStepsData: TParcelSteps = {
  [Theme.GEORGIA]: {
    "get-parcel": getParcelGE,
    "send-parcel": sendParcelGe,
  },
  [Theme.UK]: {
    "get-parcel": getParcelUk,
    "send-parcel": [],
  },
  [Theme.UZ]: {
    "get-parcel": getParcelUz,
    "send-parcel": [],
  },
};
